import React, { Component } from "react";
import { Link, Redirect } from 'react-router-dom';
import axios from "axios";
import CryptoJS from "crypto-js";

import $ from "jquery";
import Cookies from "js-cookie";
import { subsingleSignOn } from "../../../config/api_calls";
import HelperClass from "../../../config/helperClass";
import {
  clearAgentSession,
  encrypt,
  setAgentSessionTimerCookies,
  COOKIE_OPTS,
} from "../../../config/cookieUtils";
const auth = new HelperClass();

export default class SubAgentSso extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: "",
      successMessage: "",
    };
  }

  async componentDidMount() {
    let reseller_url = this.props.match.params.reseller_url;
    let token_code = this.props.match.params.token_code;

    const search = this.props.location.search;
    const agent_accountno = search.replace("?", "");

    if (reseller_url === "" && token_code === "") {
      this.setState({
        errorMessage: "URL is not valid. Please enter the valid URL.",
      });
    } else {
      let apiHit = await subsingleSignOn(
        token_code,
        reseller_url,
        agent_accountno
      );
      if (
        apiHit.data.status === 404 ||
        apiHit.data.message === "Invalid Credientials"
      ) {
        //window.location.replace("/error");
        this.setState({
          errorMessage: "Invalid credentials or expired token.",
          successMessage: "",
        });
      } else if (
        apiHit.data.status === 200 &&
        apiHit.data.message === "success"
      ) {
        //Remove Previous Session — reliable cleanup on all paths/domains
        console.info("[SSO] SubAgent SSO: Clearing previous agent session cookies");
        clearAgentSession();

        Cookies.set("tkn__", encrypt(apiHit.data.token), COOKIE_OPTS);
        Cookies.set("acn__", encrypt(apiHit.data.accountno), COOKIE_OPTS);
        Cookies.set("eml__", encrypt(apiHit.data.email), COOKIE_OPTS);
        Cookies.set("comp_nme__", encrypt(apiHit.data.comp_name), COOKIE_OPTS);
        Cookies.set("name__", encrypt(apiHit.data.name), COOKIE_OPTS);
        Cookies.set("phone__", encrypt(apiHit.data.phone), COOKIE_OPTS);
        Cookies.set("adress__", encrypt(apiHit.data.address), COOKIE_OPTS);
        Cookies.set("city__", encrypt(apiHit.data.city), COOKIE_OPTS);
        Cookies.set("state__", encrypt(apiHit.data.state), COOKIE_OPTS);
        Cookies.set("zip__", encrypt(apiHit.data.zip), COOKIE_OPTS);
        Cookies.set("country__", encrypt(apiHit.data.country), COOKIE_OPTS);
        Cookies.set("title__", encrypt(apiHit.data.title), COOKIE_OPTS);
        Cookies.set("residentifier__", encrypt(apiHit.data.reseller_url), COOKIE_OPTS);
        Cookies.set("restitle__", encrypt(apiHit.data.reseller_title), COOKIE_OPTS);
        Cookies.set("reslogo__", encrypt(apiHit.data.reseller_logo), COOKIE_OPTS);
        Cookies.set("ressig__", encrypt(apiHit.data.reseller_signature), COOKIE_OPTS);
        Cookies.set("restkn__", encrypt(apiHit.data.reseller_hash), COOKIE_OPTS);
        Cookies.set("resacct__", encrypt(apiHit.data.res_accountno), COOKIE_OPTS);
        Cookies.set("agent_type__", encrypt(apiHit.data.user_type), COOKIE_OPTS);

        // Set session timer cookies (4h default)
        setAgentSessionTimerCookies();
        console.info("[SSO] SubAgent SSO: Session timer cookies set");
        this.setState({
          errorMessage: "",
          successMessage: "Account authenticated successfully.",
        });
        setTimeout(function () {
          window.location.replace("/dashboard");
        }, 3000);
      } else {
        this.setState({
          errorMessage:
            "Your account cannot be authenticated this time. Please check the URL or try again later.",
          successMessage: "",
        });
      }
    }
  }

  render() {
    return (
      <div className="nk-content ">
        <div className="container-fluid">
          <div className="nk-content-inner">
            <div className="nk-content-body">
              {this.state.errorMessage !== "" ? (
                <div className="example-alert">
                  <div className="alert alert-pro alert-danger">
                    <div className="alert-text">
                      <h4>Error</h4>
                      <p>{this.state.errorMessage}</p>
                    </div>
                  </div>
                </div>
              ) : null}

              {this.state.successMessage !== "" ? (
                <div className="example-alert">
                  <div className="alert alert-pro alert-success">
                    <div className="alert-text">
                      <h4>Success</h4>
                      <p>{this.state.successMessage}</p>
                    </div>
                  </div>
                </div>
              ) : null}
              <div className="text-center" style={{ marginTop: "20%" }}>
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
